<template>
  <button
    :type="type"
    class="inline-flex h-10 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-gray-300 bg-white px-4 text-[13px] font-bold text-gray-700 shadow-sm transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-transparent dark:text-gray-100 dark:hover:bg-gray-800"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "PageSecondaryButton"
};
</script>

<script setup>
defineProps({
  type: {
    type: String,
    default: "button"
  }
});
</script>
